<span class="finplan-input bool">
  <mat-radio-group aria-label="Select an option" [formControl]="formControl" [value]="true">
    <mat-radio-button  value="true">{{trueName}}</mat-radio-button>
    <mat-radio-button  value="false">{{falseName}}</mat-radio-button>
  </mat-radio-group>
</span>
